// export default function Login({ onLogin }) {

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import LogoutButton from './LogOut';
import { UserAuth } from './AuthContext';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import { Header } from './Header';
const Login = () => {
const navigate = useNavigate()
  const { signUser,userFromAuth,session} = UserAuth()
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [userLOggedIn, setUserLoggedIn] = useState(''); // State to track if user is logged in
 
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {

      const result = await signUser({  email, password })
if (result){
   navigate('/emails')
}
    
    }catch(error){
setError("an errer",error)
    }
  }
  
useEffect(()=>{



   const { data: listener } = supabase.auth.onAuthStateChange(
    (event, session) => {
      if (event === 'SIGNED_IN' && session) {
        navigate('/');
      }
    }
  );

  return () => {
    listener.subscription.unsubscribe();
  };
},[])



  return (
    <div>
      <div className='' >

<Header/>
      </div>
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="w-full max-w-md bg-white rounded-lg shadow-lg p-8 text-right rtl">
        <h2 className="text-2xl font-bold mb-6 text-navy-900">تسجيل الدخول</h2>
        {error && <div className="text-red-600 text-sm mb-4">{error}</div>}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block mb-1 text-sm font-medium text-navy-800">البريد الإلكتروني</label>
            <input
              name="email"
              type="email"
              className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-navy-600"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              />
          </div>
          <div>
            <label className="block mb-1 text-sm font-medium text-navy-800">كلمة المرور</label>
            <input
              name="password"
              type="password"
              className="w-full px-4 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-navy-600"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              />
          </div>
          <button
            type="submit"
            className="w-full bg-navy-900 text-white py-2 rounded hover:bg-navy-700 transition"
            >
            دخول
          </button>
        </form>
      </div>
      
      
    </div>
            </div>
  );
};

export default Login;
